import React from 'react';
import { Main, Content } from '../../components/Layout'

export default function NoPermission() {
  return (
    <Main>
      <Content>
        <h2 class="page-title">Sem permissões</h2>
        <p className="m-0">Você não possui permissão para acessar essa página!</p>
      </Content>
    </Main>
  )
}